<template>
  <div>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-dialog persistent v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.title"
                    label="Title"
                  ></v-text-field>
                  <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.type"
                    label="Type"
                  ></v-text-field>
                </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="costCenters"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.type }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)">
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: 'cost-centers',
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "Title",
        align: "left",
        sortable: false,
        value: "title"
      },
      {
        text: "Type",
        align: "left",
        sortable: false,
        value: "type"
      },
      {
        text: "Action",
        align: "center",
        sortable: false
      },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      title: "",
      type: "",
    },
    defaultItem: {
      id: null,
      title: "",
      type: "",
    }
  }),

  computed: {
    ...mapState({
      costCenters: "costCenters"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    ...mapActions({
      createCostCenter: 'createCostCenter',
      updateCostCenter: 'updateCostCenter',
      deleteCostCenter: 'deleteCostCenter'
    }),

    editItem(item) {
      this.editedIndex = this.costCenters.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") && this.deleteCostCenter(item)
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.updateCostCenter({
          oldPosition: this.editedIndex,
          item: this.editedItem
        })
      } else {
        this.createCostCenter(this.editedItem)
      }
      this.close();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/References/CostCenters.vue